import { Component, OnInit, Input, ViewChild, TemplateRef, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CreditCardValidator } from 'angular-cc-library';
import { SubscribtionService } from '../Services/subscribtion.service';
import { Subscribe, Status, Period, AddPremiumAdToken } from '../api/WickedApiClient';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { UserService } from '../Services/user.service';
import { setAuthToken } from '../api/AuthHeaders';
import { MainService } from '../Services/service.service';

@Component({
  selector: 'app-subscribtion',
  templateUrl: './subscribtion.component.html',
  styleUrls: ['./subscribtion.component.scss'],
  encapsulation: ViewEncapsulation.None,
})


export class SubscribtionComponent implements OnInit {

  public enableSubscription:boolean = false;

  form: FormGroup;

  @ViewChild('errorDialog', { read: null, static: true }) errorDialog: TemplateRef<any>;

  creating: boolean = false;

  errorMessage: string = "";

  @Output() subscribeActionFinished = new EventEmitter();

  valueChanged() {
    this.subscribeActionFinished.emit(true);
  }

  private _isSubscriptionInfo: boolean = false;
  public get isSubscriptionInfo(): boolean {
    return this._isSubscriptionInfo;
  }

  @Input() public set isSubscriptionInfo(value: boolean) {
    this._isSubscriptionInfo = value;
  }

  public canShow: boolean = false;
  constructor(private fb: FormBuilder, private subscribtionService: SubscribtionService, private router: Router, private dialog: MatDialog, private userService: UserService, private mainService: MainService) {

    this.enableSubscription = mainService.enableSubscription;
    if(!this.enableSubscription){
        this.router.navigate(['']);
    }
    
    this.subscribtionService.hasUserSubscribtion().then((hasSubscription) => {
      this.subscribtionService.get().then(data => {
        let subscribtions = data;
        if (subscribtions.length > 0) {
          let active = subscribtions.find(v => {
            return v.status == Status.Active
          })
          if (active != undefined) {
            //this.userHasActiveSubscription = true;
            if (this.router.url == "/subscribtion") {
              this.router.navigate(['/subscription-information'])
            }
          }
          else {
            this.canShow = true;
          }
        } else {
          this.canShow = true;
        }
      });
    })


  }

  ngOnInit() {


    this.form = this.fb.group({
      firstName: ['', [<any>Validators.required]],
      lastName: ['', [<any>Validators.required]],
      zip: ['', [<any>Validators.required]],
      creditCard: ['', [<any>CreditCardValidator.validateCCNumber]],
      expirationDateYear: ['', [<any>Validators.required]],
      expirationDateMonth: ['', [<any>Validators.required]],
      cvc: ['', [<any>Validators.required, <any>Validators.minLength(3), <any>Validators.maxLength(4)]],
      subscriptionPeriod: ['']
    });
  }

  get submitButtonText(): string {
    if (this.form && Number(this.form.controls["subscriptionPeriod"].value) == Period.SinglePremiumAd) {
      return "ADD ONE CREDIT";
    }
    return "SUBSCRIBE NOW";
  }

  onSubmit() {
    console.log("submit");
    if (this.creating)
      return;

    var subscribe = new Subscribe({
      firstName: this.form.controls["firstName"].value,
      lastName: this.form.controls["lastName"].value,
      cardNumber: this.form.controls["creditCard"].value,
      expirationDate: `${this.form.controls["expirationDateYear"].value}-${this.form.controls["expirationDateMonth"].value}`,
      zip: this.form.controls["zip"].value,
      securityCode: this.form.controls["cvc"].value,
      period: Number(this.form.controls["subscriptionPeriod"].value)
    })

    if (this.form.dirty && this.form.valid) {
      if (Number(this.form.controls["subscriptionPeriod"].value) == Period.SinglePremiumAd) {
        this.creating = true;
        let tokenRequest: AddPremiumAdToken = new AddPremiumAdToken({
          cardNumber: subscribe.cardNumber,
          firstName: subscribe.firstName,
          lastName: subscribe.lastName,
          expirationDate: subscribe.expirationDate,
          zip: subscribe.zip,
          securityCode: subscribe.securityCode,
        });

        this.subscribtionService.createPremiumAdToken(tokenRequest).then((response) => {
          if (response.isError) {
            console.log('asd');
            this.errorMessage = response.message;
            this.mainService.showError(this.errorMessage);
          } else {
            this.router.navigate(['/adv-create']);
            this.valueChanged();
          }
          this.creating = false;
        })
      } else {
        this.creating = true;
        this.subscribtionService.create(subscribe).then((response) => {
          if (response.isError) {
            console.log("errorek");
            this.errorMessage = response.message;
            this.mainService.showError(this.errorMessage);
            //this.dialog.open(this.errorDialog);
          } else {
            if (response.isCreated) {
              setAuthToken(response.token);
            }

            this.router.navigate(['/subscription-information']);
            this.valueChanged();
          }
          this.creating = false;
        })
      }


      // .finally(() => {
      //     this.creating = false;
      // });
    }


  }

  public showSave: string = "0";

  show(e) {
    if (e.value == "1") {
      this.showSave = "1"
    }
    else if (e.value == "2") {
      this.showSave = "2";
    } else {
      this.showSave = "";
    }
  }
}
